import React from 'react';
import classnames from 'classnames';
import deviationFlagStyles from './DeviationFlags.scss';
export var DeviationFlagBase = function (_a) {
    var innerRef = _a.innerRef, title = _a.title;
    return (React.createElement("div", { ref: innerRef, className: deviationFlagStyles['base'] },
        React.createElement("div", { className: deviationFlagStyles['glow'] }),
        React.createElement("div", { className: classnames(deviationFlagStyles['flag'], deviationFlagStyles['green']) }),
        React.createElement("div", { className: classnames(deviationFlagStyles['flag'], deviationFlagStyles['flag-icon']) }),
        React.createElement("div", { className: deviationFlagStyles['collapsed-title'] }, title)));
};
DeviationFlagBase.displayName = 'DeviationFlagBase';
export default DeviationFlagBase;
//# sourceMappingURL=DeviationFlagBase.js.map